var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 20,
    height: 20,
    fill: "#fcfcfc",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(1.29 2.499)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Path",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(6.21 5.001)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M16.167,12.5a1.376,1.376,0,0,0,.275,1.517l.05.05a1.668,1.668,0,1,1-2.359,2.358l-.05-.05a1.386,1.386,0,0,0-2.35.983V17.5a1.667,1.667,0,1,1-3.333,0v-.075a1.375,1.375,0,0,0-.9-1.258,1.376,1.376,0,0,0-1.517.275l-.05.05a1.668,1.668,0,1,1-2.358-2.359l.05-.05a1.386,1.386,0,0,0-.983-2.35H2.5A1.667,1.667,0,1,1,2.5,8.4h.075a1.375,1.375,0,0,0,1.258-.9,1.376,1.376,0,0,0-.275-1.517l-.05-.05A1.668,1.668,0,1,1,5.867,3.575l.05.05A1.374,1.374,0,0,0,7.433,3.9H7.5a1.374,1.374,0,0,0,.833-1.258V2.5a1.667,1.667,0,1,1,3.334,0v.075a1.386,1.386,0,0,0,2.35.983l.05-.05a1.668,1.668,0,1,1,2.358,2.359l-.05.05A1.374,1.374,0,0,0,16.1,7.433V7.5a1.374,1.374,0,0,0,1.258.833H17.5a1.667,1.667,0,1,1,0,3.334h-.075A1.374,1.374,0,0,0,16.167,12.5Z",
    transform: "translate(-1.29 -2.499)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSettings);
export default __webpack_public_path__ + "static/media/profile-settings.bef184aa54420ae1d62612ccf35db208.svg";
export { ForwardRef as ReactComponent };